/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Browser_Ext_Home_Pdf_Not_Supported_DescriptionInputs */

const en_browser_ext_home_pdf_not_supported_description = /** @type {(inputs: Browser_Ext_Home_Pdf_Not_Supported_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This tab appears to be a PDF, which the extension can't process. You can upload the PDF through the extension or directly in our web app.`)
};

const es_browser_ext_home_pdf_not_supported_description = /** @type {(inputs: Browser_Ext_Home_Pdf_Not_Supported_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta pestaña parece ser un PDF y la extensión no puede procesarlo. Puedes subir el PDF desde la extensión o directamente en la app web.`)
};

/**
* | output |
* | --- |
* | "This tab appears to be a PDF, which the extension can't process. You can upload the PDF through the extension or directly in our web app." |
*
* @param {Browser_Ext_Home_Pdf_Not_Supported_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const browser_ext_home_pdf_not_supported_description = /** @type {((inputs?: Browser_Ext_Home_Pdf_Not_Supported_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browser_Ext_Home_Pdf_Not_Supported_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_browser_ext_home_pdf_not_supported_description(inputs)
	return en_browser_ext_home_pdf_not_supported_description(inputs)
});